/* eslint-disable react/destructuring-assignment */
/* eslint-disable no-unused-vars */
/* eslint-disable react/no-array-index-key */
import { DataGrid, GridToolbarContainer, GridToolbarColumnsButton, GridToolbarFilterButton, GridToolbarDensitySelector, GridToolbarExport, frFR } from '@mui/x-data-grid';
import { Link as RouterLink } from 'react-router-dom';
import { Typography, Link, Card, Avatar, Box, IconButton, Tooltip, DialogContentText, DialogActions, DialogContent, Dialog, Button, Select, MenuItem, useTheme } from '@material-ui/core';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import ArchiveRoundedIcon from '@mui/icons-material/ArchiveRounded';
import EditRoundedIcon from '@mui/icons-material/EditRounded';
import AccessTimeRoundedIcon from '@mui/icons-material/AccessTimeRounded';
import ComputerRoundedIcon from '@mui/icons-material/Computer';
import GroupsRoundedIcon from '@mui/icons-material/Groups';
import LayersRoundedIcon from '@mui/icons-material/Layers';
import SchoolRoundedIcon from '@mui/icons-material/School';
import WorkOutlineRoundedIcon from '@mui/icons-material/WorkOutline';
import StarRoundedIcon from '@mui/icons-material/StarRounded';
import PaymentsRoundedIcon from '@mui/icons-material/Payments';
import PropTypes from 'prop-types';
import useAuth from '../../../hooks/useAuth';
import { formationApi } from '../../../api/formationApi';
import toast from 'react-hot-toast';
import { useState } from 'react';

// ── Palette de dégradés déterministes pour les avatars ──
const AVATAR_GRADIENTS = [
  ['#3b82f6', '#1d4ed8'],
  ['#8b5cf6', '#6d28d9'],
  ['#06b6d4', '#0e7490'],
  ['#10b981', '#047857'],
  ['#f59e0b', '#b45309'],
  ['#ec4899', '#be185d'],
  ['#6366f1', '#4338ca'],
  ['#14b8a6', '#0f766e'],
];

const hashString = (str = '') => {
  let hash = 0;
  for (let i = 0; i < str.length; i += 1) {
    // eslint-disable-next-line no-bitwise
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  return Math.abs(hash);
};

const getInitials = (name = '') => {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return 'FO';
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return `${parts[0][0]}${parts[1][0]}`.toUpperCase();
};

// ── Pastille générique ──
const Pill = ({ icon, label, color, bg, border, mono }) => (
  <Box
    sx={{
      display: 'inline-flex',
      alignItems: 'center',
      gap: 0.5,
      px: 1.1,
      py: 0.5,
      borderRadius: '9px',
      backgroundColor: bg,
      color,
      border: '1px solid',
      borderColor: border,
      fontSize: '0.7rem',
      fontWeight: 700,
      lineHeight: 1.2,
      fontFamily: mono ? '"Roboto Mono", monospace' : 'inherit',
      letterSpacing: mono ? '0.02em' : 0,
      maxWidth: '100%',
    }}
  >
    {icon}
    <Box component="span" sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
      {label}
    </Box>
  </Box>
);

Pill.propTypes = {
  icon: PropTypes.node,
  label: PropTypes.node,
  color: PropTypes.string,
  bg: PropTypes.string,
  border: PropTypes.string,
  mono: PropTypes.bool,
};

const NEUTRAL = { color: '#64748b', bg: 'rgba(100, 116, 139, 0.07)', border: 'rgba(100, 116, 139, 0.16)' };

const getFormatStyle = (val = '') => {
  if (val.includes('E-Learning') || val.includes('E-learning')) {
    return { color: '#6366f1', bg: 'rgba(99, 102, 241, 0.09)', border: 'rgba(99, 102, 241, 0.22)', icon: <ComputerRoundedIcon sx={{ fontSize: '0.9rem' }} /> };
  }
  if (val.includes('Présentiel')) {
    return { color: '#8b5cf6', bg: 'rgba(139, 92, 246, 0.09)', border: 'rgba(139, 92, 246, 0.22)', icon: <GroupsRoundedIcon sx={{ fontSize: '0.95rem' }} /> };
  }
  if (val.includes('Mixte') || val.includes('virtuelle')) {
    return { color: '#0d9488', bg: 'rgba(20, 184, 166, 0.09)', border: 'rgba(20, 184, 166, 0.22)', icon: <LayersRoundedIcon sx={{ fontSize: '0.9rem' }} /> };
  }
  return { ...NEUTRAL, icon: <SchoolRoundedIcon sx={{ fontSize: '0.9rem' }} /> };
};

const getFinancierStyle = (name = '') => {
  if (name.includes('DPC')) return { color: '#2563eb', bg: 'rgba(59, 130, 246, 0.09)', border: 'rgba(59, 130, 246, 0.22)' };
  if (name.includes('FIFPL')) return { color: '#059669', bg: 'rgba(16, 185, 129, 0.09)', border: 'rgba(16, 185, 129, 0.22)' };
  if (name.includes('OPCO')) return { color: '#8b5cf6', bg: 'rgba(139, 92, 246, 0.09)', border: 'rgba(139, 92, 246, 0.22)' };
  if (name.includes('FIFPM')) return { color: '#d97706', bg: 'rgba(245, 158, 11, 0.1)', border: 'rgba(245, 158, 11, 0.22)' };
  return NEUTRAL;
};

// ── États du cycle de vie d'une formation (colonne « État ») ──
const ETATS = ['Active', 'Archivée', 'Brouillon'];
const DEFAULT_ETAT = 'Active';

const getEtatStyle = (val) => {
  if (val === 'Archivée') {
    return { color: '#dc2626', bg: 'rgba(239, 68, 68, 0.09)', border: 'rgba(239, 68, 68, 0.22)', icon: <ArchiveRoundedIcon sx={{ fontSize: '0.9rem' }} /> };
  }
  if (val === 'Brouillon') {
    return { color: '#d97706', bg: 'rgba(245, 158, 11, 0.11)', border: 'rgba(245, 158, 11, 0.24)', icon: <EditRoundedIcon sx={{ fontSize: '0.85rem' }} /> };
  }
  return { color: '#059669', bg: 'rgba(16, 185, 129, 0.09)', border: 'rgba(16, 185, 129, 0.22)', icon: <CheckCircleRoundedIcon sx={{ fontSize: '0.9rem' }} /> };
};

const getSatisfactionTier = (val) => {
  if (val >= 4.5) return { color: '#059669', bg: 'rgba(16, 185, 129, 0.1)', border: 'rgba(16, 185, 129, 0.25)' };
  if (val >= 3.5) return { color: '#2563eb', bg: 'rgba(59, 130, 246, 0.1)', border: 'rgba(59, 130, 246, 0.25)' };
  if (val >= 2.5) return { color: '#d97706', bg: 'rgba(245, 158, 11, 0.12)', border: 'rgba(245, 158, 11, 0.25)' };
  return { color: '#dc2626', bg: 'rgba(239, 68, 68, 0.1)', border: 'rgba(239, 68, 68, 0.25)' };
};

const Dash = () => <Typography sx={{ fontSize: '0.8rem', color: 'text.disabled' }}>—</Typography>;

const FormationResultTable = (props) => {
  const { formations, setFormations, currentPage, setCurrentPage, ...other } = props;
  const rows = [];
  const [currentIdFormation, setCurrentIdFormation] = useState(0);
  const { user } = useAuth();
  const [open, setOpen] = useState(false);
  const theme = useTheme();
  const isLight = theme.palette.mode === 'light';

  const handleClickOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const toolbarSx = {
    p: 1.5,
    px: 2,
    borderBottom: '1px solid',
    borderColor: isLight ? 'rgba(226, 232, 240, 0.7)' : 'rgba(255, 255, 255, 0.06)',
    display: 'flex',
    gap: 0.5,
    backgroundColor: isLight ? 'rgba(248, 250, 252, 0.6)' : 'rgba(15, 23, 42, 0.25)',
    '& .MuiButton-root': {
      color: '#3b82f6',
      fontWeight: 700,
      fontSize: '0.78rem',
      textTransform: 'none',
      borderRadius: '10px',
      px: 1.5,
      transition: 'all 0.15s',
      '&:hover': { backgroundColor: 'rgba(59, 130, 246, 0.08)' },
    },
  };

  const CustomToolbar = () => (
    <GridToolbarContainer sx={toolbarSx}>
      <GridToolbarColumnsButton />
      <GridToolbarFilterButton />
      <GridToolbarDensitySelector />
      {user.id_service === 0 && <GridToolbarExport />}
    </GridToolbarContainer>
  );

  formations.filter((el) => el.status !== 'Supprimée').forEach((item) => {
    rows.push({
      id: item.id,
      name: item.name,
      image: item.image,
      format: item.format,
      duration: item.duration,
      actionType: item.action_type,
      professions: item.professions,
      programNumber: item.programNumberAll,
      financiers: item.financiers,
      satisfaction: (Number(item.global_average) / 20).toFixed(1),
      etat: item.etat || DEFAULT_ETAT,
    });
  });

  const handleEtatChange = async (id, etat) => {
    const index = formations.map((el) => el.id).indexOf(id);
    const previousEtat = formations[index].etat;
    // Mise à jour optimiste : la cellule reflète immédiatement le choix.
    const tempFormations = [...formations];
    tempFormations[index] = { ...tempFormations[index], etat };
    setFormations(tempFormations);
    try {
      await formationApi.editFormation('etat', etat, id, localStorage.getItem('accessToken'));
      toast.success(`État mis à jour : ${etat}`);
    } catch (err) {
      console.error(err);
      const rollback = [...formations];
      rollback[index] = { ...rollback[index], etat: previousEtat };
      setFormations(rollback);
      toast.error('Il y a eu un souci lors de la mise à jour de l\'état !');
    }
  };

  const handleDelete = async (id) => {
    try {
      await formationApi.deleteFormation(id, localStorage.getItem('accessToken'));
      const tempFormations = [...formations];
      tempFormations[formations.map((el) => el.id).indexOf(id)].status = 'Supprimée';
      setFormations(tempFormations);
      toast.success('Formation supprimée !');
      handleClose();
    } catch (err) {
      console.error(err);
      toast.error('Il y a eu un souci lors de la suppression !');
    }
  };

  const columns = [
    {
      field: 'name',
      headerName: 'Formation',
      width: 380,
      renderCell: (cellValues) => {
        const name = cellValues.row.name || '';
        const grad = AVATAR_GRADIENTS[hashString(name) % AVATAR_GRADIENTS.length];
        const prog = cellValues.row.programNumber;
        return (
          <Box sx={{ display: 'flex', alignItems: 'center', py: 0.5, width: '100%' }}>
            <Avatar
              src={cellValues.row.image || undefined}
              sx={{
                height: 46,
                width: 46,
                borderRadius: '14px',
                fontSize: '0.95rem',
                fontWeight: 800,
                color: '#fff',
                boxShadow: `0 6px 16px ${grad[0]}40`,
                border: isLight ? '2px solid #fff' : '2px solid rgba(255,255,255,0.08)',
                background: `linear-gradient(135deg, ${grad[0]} 0%, ${grad[1]} 100%)`,
                flexShrink: 0,
              }}
            >
              {getInitials(name)}
            </Avatar>
            <Box sx={{ ml: 1.75, minWidth: 0 }}>
              <Link
                component={RouterLink}
                to={`/dashboard/formations/${cellValues.row.id}`}
                sx={{
                  textDecoration: 'none',
                  fontWeight: 700,
                  fontSize: '0.86rem',
                  color: 'text.primary',
                  lineHeight: 1.3,
                  transition: 'color 0.15s',
                  display: 'block',
                  '&:hover': { color: '#3b82f6' },
                }}
              >
                {name}
              </Link>
              {prog && prog !== 'N/A' ? (
                <Typography
                  sx={{
                    mt: 0.3,
                    fontSize: '0.68rem',
                    fontWeight: 600,
                    color: 'text.secondary',
                    fontFamily: '"Roboto Mono", monospace',
                    letterSpacing: '0.02em',
                  }}
                >
                  N° {prog}
                </Typography>
              ) : (
                <Typography sx={{ mt: 0.3, fontSize: '0.68rem', fontWeight: 600, color: 'text.disabled' }}>
                  Sans n° de programme
                </Typography>
              )}
            </Box>
          </Box>
        );
      },
    },
    {
      field: 'etat',
      headerName: 'État',
      width: 160,
      type: 'singleSelect',
      valueOptions: ETATS,
      renderCell: (cellValues) => {
        const val = cellValues.value || DEFAULT_ETAT;
        const s = getEtatStyle(val);
        const canEdit = user.id_service === 0 || user.access_level === 0;
        return (
          <Select
            value={val}
            variant="standard"
            disableUnderline
            readOnly={!canEdit}
            onChange={(event) => handleEtatChange(cellValues.row.id, event.target.value)}
            renderValue={(v) => {
              const style = getEtatStyle(v);
              return <Pill icon={style.icon} label={v} color={style.color} bg={style.bg} border={style.border} />;
            }}
            MenuProps={{ PaperProps: { sx: { borderRadius: '12px', mt: 0.5 } } }}
            sx={{
              '& .MuiSelect-select': {
                p: 0,
                pr: canEdit ? '22px !important' : '0 !important',
                display: 'flex',
                alignItems: 'center',
                minHeight: 'auto !important',
                backgroundColor: 'transparent !important',
              },
              '& .MuiSelect-icon': {
                display: canEdit ? 'block' : 'none',
                right: 0,
                color: s.color,
              },
              cursor: canEdit ? 'pointer' : 'default',
            }}
          >
            {ETATS.map((etat) => {
              const style = getEtatStyle(etat);
              return (
                <MenuItem key={etat} value={etat} sx={{ fontSize: '0.8rem', fontWeight: 600, gap: 1 }}>
                  <Box sx={{ display: 'inline-flex', alignItems: 'center', color: style.color }}>{style.icon}</Box>
                  {etat}
                </MenuItem>
              );
            })}
          </Select>
        );
      },
    },
    {
      field: 'format',
      headerName: 'Format',
      width: 150,
      renderCell: (cellValues) => {
        const val = cellValues.value || '';
        if (!val) return <Dash />;
        const s = getFormatStyle(val);
        return <Pill icon={s.icon} label={val} color={s.color} bg={s.bg} border={s.border} />;
      },
    },
    {
      field: 'duration',
      headerName: 'Durée',
      width: 100,
      renderCell: (cellValues) => {
        if (!cellValues.value) return <Dash />;
        return (
          <Pill
            icon={<AccessTimeRoundedIcon sx={{ fontSize: '0.9rem' }} />}
            label={`${cellValues.value} h`}
            color="#475569"
            bg="rgba(100, 116, 139, 0.07)"
            border="rgba(100, 116, 139, 0.16)"
          />
        );
      },
    },
    {
      field: 'actionType',
      headerName: 'Action',
      width: 180,
      renderCell: (cellValues) => {
        if (!cellValues.value) return <Dash />;
        return (
          <Pill
            icon={<WorkOutlineRoundedIcon sx={{ fontSize: '0.85rem' }} />}
            label={cellValues.value}
            color="#475569"
            bg="rgba(100, 116, 139, 0.06)"
            border="rgba(100, 116, 139, 0.14)"
          />
        );
      },
    },
    {
      field: 'professions',
      headerName: 'Professions',
      width: 250,
      renderCell: (cellValues) => {
        const val = cellValues.value || '';
        if (!val || val === '—') return <Dash />;
        const list = val.split(',').map((p) => p.trim()).filter(Boolean);
        const visible = list.slice(0, 2);
        const rest = list.slice(2);
        return (
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, py: 0.5 }}>
            {visible.map((prof, idx) => (
              <Pill key={idx} label={prof} color="#0d9488" bg="rgba(20, 184, 166, 0.08)" border="rgba(20, 184, 166, 0.2)" />
            ))}
            {rest.length > 0 && (
              <Tooltip
                title={rest.join(', ')}
                arrow
                componentsProps={{ tooltip: { sx: { fontSize: '0.72rem', fontWeight: 600, borderRadius: '8px' } } }}
              >
                <Box
                  sx={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    px: 0.9,
                    py: 0.5,
                    borderRadius: '9px',
                    backgroundColor: 'rgba(20, 184, 166, 0.12)',
                    color: '#0f766e',
                    border: '1px solid rgba(20, 184, 166, 0.25)',
                    fontSize: '0.68rem',
                    fontWeight: 800,
                    cursor: 'default',
                  }}
                >
                  +{rest.length}
                </Box>
              </Tooltip>
            )}
          </Box>
        );
      },
    },
    {
      field: 'financiers',
      headerName: 'Financeurs',
      width: 175,
      renderCell: (cellValues) => {
        const val = cellValues.value || '';
        if (!val) return <Dash />;
        const list = val.split(',').map((f) => f.trim()).filter(Boolean);
        return (
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
            {list.map((fin, idx) => {
              const s = getFinancierStyle(fin);
              return (
                <Pill
                  key={idx}
                  icon={<PaymentsRoundedIcon sx={{ fontSize: '0.8rem' }} />}
                  label={fin}
                  color={s.color}
                  bg={s.bg}
                  border={s.border}
                />
              );
            })}
          </Box>
        );
      },
    },
    {
      field: 'satisfaction',
      headerName: 'Satisfaction',
      width: 150,
      renderCell: (cellValues) => {
        const val = Number(cellValues.value);
        if (Number.isNaN(val) || val <= 0) {
          return <Typography sx={{ fontSize: '0.72rem', color: 'text.disabled', fontStyle: 'italic' }}>Pas d&apos;évaluation</Typography>;
        }
        const tier = getSatisfactionTier(val);
        return (
          <Box
            sx={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: 0.5,
              pl: 0.6,
              pr: 1.1,
              py: 0.45,
              borderRadius: '10px',
              backgroundColor: tier.bg,
              border: '1px solid',
              borderColor: tier.border,
            }}
          >
            <StarRoundedIcon sx={{ fontSize: '1.05rem', color: tier.color }} />
            <Typography sx={{ fontSize: '0.82rem', fontWeight: 800, color: tier.color, lineHeight: 1 }}>
              {val.toFixed(1)}
            </Typography>
            <Typography sx={{ fontSize: '0.68rem', fontWeight: 600, color: tier.color, opacity: 0.65, lineHeight: 1 }}>
              /5
            </Typography>
          </Box>
        );
      },
    },
    {
      field: 'actions',
      headerName: '',
      width: 64,
      sortable: false,
      filterable: false,
      disableExport: true,
      renderCell: (cellValues) => (
        <Tooltip title="Supprimer" arrow>
          <span>
            <IconButton
              onClick={() => { setCurrentIdFormation(cellValues.row.id); handleClickOpen(); }}
              disabled={user.id_service !== 0 && user.access_level !== 0}
              size="small"
              sx={{
                color: 'text.secondary',
                borderRadius: '10px',
                transition: 'all 0.18s',
                '&:hover': { backgroundColor: 'rgba(239, 68, 68, 0.1)', color: '#ef4444', transform: 'translateY(-1px)' },
              }}
            >
              <DeleteOutlineIcon sx={{ fontSize: '1.2rem' }} />
            </IconButton>
          </span>
        </Tooltip>
      ),
    },
  ];

  return (
    <Card
      sx={{
        border: '1px solid',
        borderColor: isLight ? 'rgba(226, 232, 240, 0.6)' : 'rgba(255, 255, 255, 0.06)',
        borderRadius: '24px',
        overflow: 'hidden',
        boxShadow: isLight ? '0 12px 40px rgba(15, 23, 42, 0.05)' : '0 12px 40px rgba(0, 0, 0, 0.3)',
        background: isLight ? '#fff' : 'rgba(30, 41, 59, 0.45)',
      }}
      {...other}
    >
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        PaperProps={{ style: { borderRadius: '20px', padding: '10px' } }}
      >
        <DialogContent>
          <DialogContentText sx={{ fontWeight: 600, color: 'text.primary' }}>
            Souhaitez-vous vraiment supprimer cette formation ? Cette action est irréversible.
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button
            onClick={() => handleDelete(currentIdFormation)}
            sx={{
              color: '#ef4444',
              fontWeight: 700,
              textTransform: 'none',
              borderRadius: '10px',
              '&:hover': { backgroundColor: 'rgba(239, 68, 68, 0.05)' },
            }}
          >
            Supprimer
          </Button>
          <Button
            onClick={handleClose}
            autoFocus
            variant="contained"
            sx={{
              background: 'linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)',
              color: '#fff',
              fontWeight: 700,
              textTransform: 'none',
              borderRadius: '10px',
              boxShadow: '0 4px 12px rgba(59, 130, 246, 0.25)',
              '&:hover': { background: 'linear-gradient(135deg, #2563eb 0%, #1e40af 100%)' },
            }}
          >
            Annuler
          </Button>
        </DialogActions>
      </Dialog>
      <DataGrid
        sx={{
          border: 'none',
          fontFamily: 'inherit',
          // ── En-têtes ──
          '& .MuiDataGrid-columnHeaders': {
            backgroundColor: isLight ? 'rgba(248, 250, 252, 0.9)' : 'rgba(15, 23, 42, 0.4)',
            borderBottom: '1px solid',
            borderColor: isLight ? 'rgba(226, 232, 240, 0.8)' : 'rgba(255, 255, 255, 0.08)',
            borderRadius: 0,
            minHeight: '52px !important',
            maxHeight: '52px !important',
          },
          '& .MuiDataGrid-columnHeaderTitle': {
            fontWeight: 800,
            fontSize: '0.7rem',
            textTransform: 'uppercase',
            letterSpacing: '0.07em',
            color: 'text.secondary',
          },
          '& .MuiDataGrid-columnSeparator': { display: 'none' },
          // ── Lignes ──
          '& .MuiDataGrid-row': {
            transition: 'background-color 0.15s ease, box-shadow 0.15s ease',
          },
          '& .MuiDataGrid-row:nth-of-type(even)': {
            backgroundColor: isLight ? 'rgba(248, 250, 252, 0.45)' : 'rgba(255, 255, 255, 0.015)',
          },
          '& .MuiDataGrid-row:hover': {
            backgroundColor: isLight ? 'rgba(59, 130, 246, 0.05)' : 'rgba(59, 130, 246, 0.09)',
            boxShadow: 'inset 3px 0 0 0 #3b82f6',
          },
          // ── Cellules ──
          '& .MuiDataGrid-cell': {
            borderColor: isLight ? 'rgba(226, 232, 240, 0.4)' : 'rgba(255, 255, 255, 0.04)',
            whiteSpace: 'normal !important',
            wordBreak: 'break-word !important',
            display: 'flex !important',
            alignItems: 'center !important',
          },
          '& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within': { outline: 'none !important' },
          '& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within': { outline: 'none !important' },
          '& .MuiDataGrid-cell[data-field="name"]': {
            whiteSpace: 'normal !important',
            lineHeight: '1.3 !important',
            py: '8px !important',
          },
          // ── Pied / pagination ──
          '& .MuiDataGrid-footerContainer': {
            borderTop: '1px solid',
            borderColor: isLight ? 'rgba(226, 232, 240, 0.8)' : 'rgba(255, 255, 255, 0.08)',
            backgroundColor: isLight ? 'rgba(248, 250, 252, 0.5)' : 'rgba(15, 23, 42, 0.3)',
          },
          '& .MuiTablePagination-root': { color: 'text.secondary' },
          '& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows': { fontWeight: 600, fontSize: '0.78rem' },
          '& .MuiDataGrid-selectedRowCount': { color: '#3b82f6', fontWeight: 600 },
          '& .MuiDataGrid-virtualScroller': { backgroundColor: 'transparent' },
        }}
        localeText={frFR.components.MuiDataGrid.defaultProps.localeText}
        initialState={{
          sorting: { sortModel: [{ field: 'name', sort: 'asc' }] },
        }}
        autoHeight
        rowHeight={74}
        rows={rows}
        columns={columns}
        page={currentPage}
        pageSize={20}
        rowsPerPageOptions={[30, 100]}
        disableSelectionOnClick
        components={{ Toolbar: CustomToolbar }}
        onPageChange={(newPage) => { setCurrentPage(newPage); }}
      />
    </Card>
  );
};

FormationResultTable.propTypes = {
  formations: PropTypes.array,
  setFormations: PropTypes.func.isRequired,
  currentPage: PropTypes.number.isRequired,
  setCurrentPage: PropTypes.func.isRequired,
};

export default FormationResultTable;
